import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
    providedIn: 'root'
})
export class BannerService {
    private docNo: string = '';
    allMessages: BannerMessage[] = [];
    messageSubject: Subject<BannerMessage[]>;
    constructor() {
        this.messageSubject = new Subject<BannerMessage[]>()
        this.messageSubject.subscribe(value => console.log(value))
    }
    public addMessage(message: BannerMessage, docNo: string) {
        if (this.isValidationMessage(message.content))
            this.allMessages = this.allMessages.filter(x => !this.isValidationMessage(x.content))
        //set document number
        if (this.docNo.length == 0) this.docNo = docNo
        //document number is different from previous number, clear previous messages
        else if (this.docNo !== docNo) {
            this.docNo = docNo
            this.clearMessages()
        }
        const arr = [...this.allMessages, message]
        this.messageSubject.next(arr)
    }
    public clearMessages() {
        this.allMessages = []
        this.messageSubject.next(this.allMessages)
    }
    private isValidationMessage(message: string) {
        return message.indexOf('Please correct the errors in the following tabs') !== -1
    }
    public clearValidationMessages(){
        this.allMessages = this.allMessages.filter(x => !this.isValidationMessage(x.content))
        this.messageSubject.next(this.allMessages)
    }
}
export interface BannerMessage {
    type: BannerType
    content: string
}
export enum BannerType {
    info,
    warning,
    error
}